/*
 * @Description: 订运单单api
 * @Author: sunxiaodong
 * @Date: 2020-08-07 17:12:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-09 10:03:30
 */
import http from "e6-base-core/axios/config";

import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_E6YUN_BASE_WEB,
  E6_MS_TMS_BUSI_WEB,
  E6_MS_TMS_BASE_WEB,
  E6_MS_TMS_CUSTOMER_WMZ_WEB
} = e6ModuleOrderWaybillProcessApi;

// const mockURL = "/mock/5f27a2353d490a0020085574/privite";
// ------------------------ 订单列表 ------------------------

// 获取订单列表
export function getOrderList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/list`,
    method: "post",
    data
  });
}

// 获取订单条数
export function getOrderCount(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/count`,
    method: "post",
    data
  });
}
// 删除订单
export function deleteOrder(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/delete`,
    method: "post",
    data
  });
}

// 获取货物详情
export function getGoodsDeatil(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/orderGoods/list`,
    method: "get",
    params
  });
}

// 获取区域下拉
export function getAreaLablePosition(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}
// 获取区域下拉（新接口）
export function getAreaLablePositionNew(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}

// 获取客户/承运商下拉
export function getListCustomerCarrier(data) {
  let url = "";
  switch (data.type) {
    case 1:
      url = "/customerCarrier/findAllCustomerByPage";
      break;
    case 2:
      url = "/customerCarrier/findAllCarrierByPage";
      break;
    default:
      break;
  }
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}${url}`,
    method: "post",
    data
  });
}

// 获取订单状态下拉
export function getOrderStatusList() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/flowNode/getNodeListByCorpId`,
    method: "get"
  });
}

// 获取业务类型下拉
export function getUsedBusinessTypeList() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/flowBusinessType/getUsedBusinessTypeList`,
    method: "get"
  });
}

// 获取字典值下拉
export function getPageByCondition(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}

// 获取部门树结构下拉
export function getDepartmentTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}

// 获取辅助状态下拉
export function getAssistStatusesList() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderAssistanceStatus`,
    method: "get"
  });
}

// 订单委派
export function orderDelegate(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/delegate`,
    method: "post",
    data
  });
}

// 订单分配
export function orderDistribution(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/distribution`,
    method: "post",
    data
  });
}
//导出订单信息
export function exportOrder(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/exportOrderInfo`,
    method: "post",
    data
  });
}

// 获取订单扩展字段
export function getExtendSearchInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/getExtendSearchInfo`,
    method: "post",
    data
  });
}

// ------------------------ 订单新增 ------------------------
// 货物查询
export function getGoodsList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/findGoodsByType/page`,
    method: "post",
    data
  });
}

// 订单新增/修改
export function orderSave(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/save`,
    method: "post",
    data
  });
}
// 根据区域id获取收发货人信息
export function getShipperReceiverByAreaId(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/getShipperReceiverByAreaId?customAreaId=${data}`,
    method: "get"
  });
}

// 订单号唯一性校验
export function orderUniq(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/orderNo/repeat`,
    method: "post",
    data
  });
}

// 获取唯一订单号
export function getOrderUniq() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/orderNo`,
    method: "post"
  });
}

// 订单详情【修改用】
export function orderInfoDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/details`,
    method: "get",
    params
  });
}
// 订单备注修改
export function saveOrderRemark(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/orderRemarkSave`,
    method: "post",
    data
  });
}
// 订单时间修改
export function modifyOrderTime(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/modifyOrderTime`,
    method: "post",
    data
  });
}

/************************订单派车相关接口*************************/

// 订单派车-查询运单详情
export function getOrderSendDetails(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/getOrderInfoForAssignVehicle`,
    method: "get",
    params
  });
}

// 订单派车
export function fatchOrderAssignVehicle(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/assignVehicle`,
    method: "post",
    data
  });
}
// 派车页面查询车辆信息
export function fatchQueryVehicleInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/pageQueryVehicleInfo`,
    method: "post",
    data
  });
}
// 获取送货员数据
export function findAllDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/findAllDelivery`,
    method: "post",
    data
  });
}
// 根据车辆ID查询车辆详情
export function findDeliveriesByVehicleId(id) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/findDeliveriesByVehicleId`,
    method: "get",
    params: id
  });
}

// 根据车辆ID查询司机（主+2副）
export function fetchDriversById(id) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getDriversByVehicleId`,
    method: "get",
    params: id
  });
}

/************************订单配载相关接口 START*************************/
// 订单配载任务列表查询[历史订单配载]
export function orderStowageTask(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/list`,
    method: "post",
    data
  });
}

// 订单配载任务列表统计[历史订单配载]
export function orderStowageCount(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/count`,
    method: "post",
    data
  });
}

// 订单配载设置保存
export function setOrderStowageSetting(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/orderStowageSetting/save`,
    method: "post",
    data
  });
}

// 订单配载设置查询
export function getOrderStowageSetting() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/orderStowageSetting/list`,
    method: "get"
  });
}

// 订单配载订单列表查询【订单配载】
export function findOrderStowage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderStowage`,
    method: "post",
    data
  });
}

// 订单数量统计接口【订单配载】
export function countOrderInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/countOrderInfo`,
    method: "post",
    data
  });
}

// 根据电子路书名称，途径点进行模糊查询【订单配载】
export function findFixedBillWayPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findFixedBillWay/page`,
    method: "post",
    data
  });
}
// 根据电子路书名称，途径点进行模糊查询【订单配载】
export function getFixedLineInfoDropBox(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/getFixedLineInfoDropBox`,
    method: "post",
    data
  });
}

// 根据电子路书名称与途径点查询所有的电子路数id列表【订单配载】
export function findAllFixedIds(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/fixed/findAllFixedIds`,
    method: "get",
    params
  });
}

// 订单配载-运单查询接口【订单配载】
export function stowagePageQueryWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/stowagePageQueryWaybill`,
    method: "post",
    data
  });
}

// 获取所有运单id【订单配载】
export function selectAllWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/selectAllWaybill`,
    method: "post",
    data
  });
}

// 配载【订单配载】
export function orderStowageTaskSave(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/save`,
    method: "post",
    data
  });
}
/************************订单配载相关接口 END*************************/
/************************确认配载结果相关接口 START *************************/
// 查看订单【确认配载结果】
export function confirmFindOrderNode(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderNode`,
    method: "post",
    data
  });
}
// 确认结果【确认配载结果】
export function confirmResult(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/confirmResult`,
    method: "post",
    data
  });
}
// 导出确认结果【确认配载结果】
export function confirmExport(params) {
  return http({
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/exportStowageResult`,
    method: "get",
    params
  });
}
// 配载【确认配载结果】
export function confirmGenerateWaybillStowage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/generateWaybillFromStowage`,
    method: "post",
    data
  });
}
// 通过车辆Id查询车辆载重载积
export function vehicleInfo(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/vehicleInfo`,
    method: "get",
    params
  });
}
// 配载【未配载订单列表】
export function getUnStowageOrderList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderStowageTask/unStowageOrderList`,
    method: "post",
    data
  });
}
/************************确认配载结果相关接口 END *************************/

//获取订单更改记录
export function fetchOrderUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfoHistory/findByPage`,
    method: "post",
    data
  });
}
//获取订单更改记录对比信息
export function fetchOrderUpdateRecordContrast(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfoHistory/findOrderList`,
    method: "post",
    data
  });
}
//获取更改记录中的货物详情
export function fetchRecordGoodsDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfoHistory/orderGoods/list/${params.orderNo}/${params.version}`,
    method: "get"
  });
}

//更改记录 用户下拉树
export function fetchUserTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getUserTree`,
    method: "get"
  });
}

/************************订单详情相关接口 START*************************/
//上传回单查询
export function getOrdersUpload(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/getOrders`,
    method: "get",
    params
  });
}

//上传回单保存
export function uploadTheReceipt(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/uploadTheReceipt`,
    method: "post",
    data
  });
}

// 回单审核查询
export function getTheReceipts(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/getTheReceipts`,
    method: "get",
    params
  });
}

// 回单审核保存
export function reviewTheReceiptSave(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/reviewTheReceiptSave`,
    method: "post",
    data
  });
}

// 回单复审查询
export function getReviewReceipts(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/getReviewReceipts`,
    method: "get",
    params
  });
}

// 回单复审保存
export function returnsTheReviewSave(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderEvent/returnsTheReviewSave`,
    method: "post",
    data
  });
}
/************************订单详情相关接口*************************/
//获取订单详情横轴
export function getOrderMonitorList(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/businessStateHistory/getOrderMonitorList`,
    // url: `${mockURL}/businessStateHistory/getOrderMonitorList`,
    method: "get",
    params
  });
}

//获取订单详情基础数据
export function findOrderById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderDetails/findOrderById`,
    // url: `${mockURL}/orderDetails/findOrderById`,
    method: "get",
    params
  });
}

//获取订单详情运输信息
export function findWaybillById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderDetails/findWaybillByOrderId`,
    // url: `${mockURL}/orderDetails/findWaybillByOrderId`,
    method: "get",
    params
  });
}

//获取订单详情订单事件
export function findEvent(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderDetails/findOrderEventById`,
    // url: `${mockURL}/orderDetails/findEvent`,
    method: "get",
    params
  });
}

//获取订单详情订单其他
export function findOther(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderDetails/findOrderExpandById`,
    // url: `${mockURL}/orderDetails/findOther`,
    method: "get",
    params
  });
}
/************************订单详情相关接口 END*************************/
// 根据ID查询车型(确认配载)
export function getByIdCarModel(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findById`,
    method: "get",
    params
  });
}

// 拉取运单号
export function getAreaSortOrderList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/getAreaSortOrderList`,
    method: "post",
    data
  });
}

//新增自定义区域保存
export function saveSelfDefineArea(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/saveArea`,
    method: "post",
    data
  });
}
//校验自定义区域的手机号和联系人
export function checkShipperReceiver(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/checkShipperReceiver`,
    method: "post",
    data
  });
}
//拆零相关获取表头
// 0:新建订单表头;1:确认装货表头;2:确认交货表头;3:确认签收表头;
// 4:转运表头;5:订单详情-货物信息;6:货物详情-货物信息
export function fetchSplitColumn(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/getDisplayOfGoodsField`,
    method: "get",
    params
  });
}

// 根据订单id批量查询订单货物信息
export function fetchGoodsInfoByOrderId(data) {
  return http({
    url: `${host}${E6_MS_TMS_CUSTOMER_WMZ_WEB}/batch/order/getGoodsInfo`,
    method: "post",
    data
  });
}
// 批量确认装货
export function batchAffirmShipment(data) {
  return http({
    url: `${host}${E6_MS_TMS_CUSTOMER_WMZ_WEB}/batch/order/confirmShipment`,
    method: "post",
    data
  });
}
// 批量确认交货
export function batchAffirmDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_CUSTOMER_WMZ_WEB}/batch/order/confirmDelivery`,
    method: "post",
    data
  });
}

// 货物下拉框
export function getGoodsDropBox(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/goods/info/dropBox`,
    method: "post",
    data
  });
}

// 省市区下拉
export function getProvinceCityDropBox(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getProvinceCityDropBox`,
    method: "post",
    data
  });
}

// 配送周期下拉
export function getDeliveryCycle(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/getDeliveryCycle`,
    method: "get",
    params
  });
}
// 签收状态下拉
export function findOrderSignStatus() {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderSignStatus`,
    method: "get"
  });
}
// 重新推送 E6-MS-TMS-BUSI-WEB/orderInfo/rePush?id=7837822830467243008
export function repushOrder(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/rePush`,
    method: "get",
    params
  });
}
// 补充签收
export function supplementSign(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/supplementSign`,
    method: "post",
    data
  });
}
